
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.338 2C17.669 2 22 6.393 22 11.795c0 1.886-.148 2.58-.58 4.338a1.078 1.078 0 01-.673.739L6.373 21.936a1.013 1.013 0 01-.347.064c-.316 0-.61-.136-.822-.389l-2.611-3.08c-.261-.322-.058-.794.354-.85 5.791-.795 10.05-4.254 11.109-5.223a2.102 2.102 0 001.552-2.586c-.243-.945-1.157-1.563-2.132-1.563H4.112c-.385 0-.65-.405-.48-.749C5.354 4.089 8.732 2 12.338 2zm-8.963 8.405l8.088.01c0 .432.126.842.358 1.179-1.572 1.23-5.026 3.528-9.228 4.087a.527.527 0 01-.589-.588c.085-.664.637-3.26.856-4.277a.52.52 0 01.515-.411z","fill":"#6b6b6b","fill-rule":"evenodd"}})])
          )
        }
      }
    